import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { shareReplay } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { PracticeAreas } from "../models/practiceAreas";
import { MemberProfile } from "../models/profile";
import { User } from "../models/user";
import { SharedReplayRefresh } from "../util/SharedReplayRefresh";

@Injectable({
  providedIn: "root"
})
export class UserService {

  private createHeader() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return httpOptions;
  }

  constructor(private httpClient: HttpClient) { }

  private dataSource = new SharedReplayRefresh<User>();
  private source = this.httpClient.get<User>(`${environment.ApiEndpoint}/User/GetOrCreateUserBySession`, this.createHeader())

  public user(): Observable<User> {
    return this.dataSource.sharedReplayTimerRefresh(this.source, 1, 3000000);
  }
     
  public refreshUser(): Observable<User> {
    return this.source;
  }

  public profile(): Observable<MemberProfile> {
      return this.httpClient.get<MemberProfile>(`${environment.ApiEndpoint}/User/GetUserProfile`, this.createHeader()).pipe(shareReplay());
  }

  public practiceAreas(): Observable<PracticeAreas> {
    return this.httpClient.get<PracticeAreas>(`${environment.ApiEndpoint}/User/GetUserPracticeAreas`, this.createHeader()).pipe(shareReplay());
}
}